import { Module } from 'vuex/types';

import item from './item';

export default {
  namespaced: true,

  modules: {
    panels: item('panels'),
    inverters: item('inverters'),
    meters: item('meters'),
    inverterConfigurations: item('inverter-configurations'),
  },

  actions: {
    ['fetch:all']({ dispatch }) {
      dispatch('inverterConfigurations/fetch');
      dispatch('panels/fetch');
      dispatch('inverters/fetch');
      dispatch('meters/fetch');
    },
  },
} as Module<any, any>;
